import "core-js/modules/es.string.trim";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getBairunSvcRechargeOrderList, exportBairunSvcBalanceOptLogList } from '@/api/bairun/svcRechargeConsumeLog';
import { getStationBaseInfoList } from '@/api/bairun/stationBaseInfo';
import { getBairunPayChannelList } from '@/api/bairun/bairunPayChannel';
import { formatTimeToStr } from '@/utils/date';
import infoList from '@/mixins/infoList';
import SearchTerm from '@/components/searchTerm';
import { mapGetters } from 'vuex';

var _this;

export default {
  name: 'BairunSvcRechargeConsumeLog',
  filters: {
    formatDate: function formatDate(time) {
      if (time != null && time !== '') {
        var date = new Date(time);
        return formatTimeToStr(date, 'yyyy-MM-dd hh:mm:ss');
      } else {
        return '';
      }
    },
    getStationName: function getStationName(id) {
      for (var i = 0; i < _this.stationOptions.length; i++) {
        if (_this.stationOptions[i].ID === id) {
          return _this.stationOptions[i].stationName;
        }
      }

      return '';
    },
    getPayChannelName: function getPayChannelName(payChannel) {
      for (var i = 0; i < _this.payChannelOptions.length; i++) {
        if (_this.payChannelOptions[i].payChannel == payChannel) {
          return _this.payChannelOptions[i].cnName;
        }
      }

      return '';
    }
  },
  mixins: [infoList],
  components: {
    SearchTerm: SearchTerm
  },
  computed: _objectSpread({}, mapGetters('stations', ['allStationMap', 'allStations'])),
  data: function data() {
    return {
      listApi: getBairunSvcRechargeOrderList,
      loading: false,
      downloading: false,
      searchInfo: {
        // 按配置顺序显示
        'svcNumber': '',
        'svcOptNumber': '',
        'mobile': '',
        'activeStationId': '',
        'orderOptType': '',
        'startTime': '',
        'endTime': ''
      },
      type: '',
      exportVisible: false,
      multipleSelection: [],
      stationOptions: [],
      payChannelOptions: [],
      svcOrderOptTypeOptions: [],
      formData: {
        svcNumber: '',
        startTime: '',
        endTime: ''
      }
    };
  },
  beforeCreate: function beforeCreate() {
    _this = this;
  },
  activated: function activated() {// 使用keepalive的页面,重新展示都会调用

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  created: function created() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              // 使用keepalive的页面,重新展示不会调用
              console.log('created');

              _this2.init();

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  methods: {
    init: function init() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var stationOptions, payChannelOptions;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return getStationBaseInfoList({
                  page: 1,
                  pageSize: 999999,
                  donNotShowLoading: true
                });

              case 2:
                stationOptions = _context3.sent;
                _this3.stationOptions = stationOptions.data.list;
                _context3.next = 6;
                return getBairunPayChannelList({
                  page: 1,
                  pageSize: 999999,
                  donNotShowLoading: true
                });

              case 6:
                payChannelOptions = _context3.sent;
                _this3.payChannelOptions = payChannelOptions.data.list;
                _context3.next = 10;
                return _this3.getDict('svcOrderOptType');

              case 10:
                _this3.svcOrderOptTypeOptions = _context3.sent;

              case 11:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    onSearch: function onSearch() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this4.page = 1;
                _this4.pageSize = 10;
                _this4.loading = true;
                _context4.next = 5;
                return _this4.getTableData();

              case 5:
                _this4.loading = false;

              case 6:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    onClose: function onClose() {
      this.exportVisible = false;
      this.formData = {
        svcNumber: '',
        startTime: '',
        endTime: ''
      };
    },
    onDownload: function onDownload() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var res;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this5.downloading = true;
                _context5.next = 3;
                return exportBairunSvcBalanceOptLogList(_this5.searchInfo);

              case 3:
                res = _context5.sent;

                if (res.code === 0) {
                  window.open(res.data.fileUrl);
                }

                _this5.downloading = false;

              case 6:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },
    onExport: function onExport() {
      this.exportVisible = true;
      this.type = 'export';
    },
    doExport: function doExport() {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var param, res;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                param = {};

                if (_this6.formData.svcNumber.trim()) {
                  _context6.next = 4;
                  break;
                }

                _this6.$message({
                  type: 'warning',
                  message: '请输入卡号'
                });

                return _context6.abrupt("return");

              case 4:
                if (!(!_this6.formData.startTime || !_this6.formData.endTime)) {
                  _context6.next = 7;
                  break;
                }

                _this6.$message({
                  type: 'warning',
                  message: '请选择时间'
                });

                return _context6.abrupt("return");

              case 7:
                if (_this6.formData.startTime) {
                  param.startTime = _this6.$options.filters.formatDate(_this6.formData.startTime);
                }

                if (_this6.formData.endTime) {
                  param.endTime = _this6.$options.filters.formatDate(_this6.formData.endTime);
                }

                if (!(!param.startTime || !param.endTime)) {
                  _context6.next = 12;
                  break;
                }

                _this6.$message({
                  type: 'warning',
                  message: '请选择开始、结束时间'
                });

                return _context6.abrupt("return");

              case 12:
                if (!(new Date(param.startTime).getTime() > new Date(param.endTime).getTime())) {
                  _context6.next = 15;
                  break;
                }

                _this6.$message({
                  type: 'warning',
                  message: '开始时间不能大于结束时间'
                });

                return _context6.abrupt("return");

              case 15:
                // if (!isBeforeMonth(param.startTime, param.endTime, 3)) {
                //   this.$message({
                //     type: 'warning',
                //     message: '时间范围不能大于3个自然月'
                //   })
                //   return
                // }
                param.svcNumber = _this6.formData.svcNumber.trim();
                _context6.next = 18;
                return exportBairunSvcBalanceOptLogList(param);

              case 18:
                res = _context6.sent;

                if (res.code === 0) {
                  window.open(res.data.fileUrl);
                }

              case 20:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }))();
    }
  }
};